import styled from '@emotion/styled'
import { theme } from '../../styles/themes/default'

/**
 * Verde oficial do WhatsApp. O fundo sólido garante contraste do rótulo branco
 * mesmo quando o footer está com o tema escuro (que força `color: #fff`).
 */
const WHATSAPP_GREEN = '#25D366'
const WHATSAPP_GREEN_HOVER = '#1DA851'

export const WhatsAppLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  padding: 0.75rem 1.25rem;
  border-radius: 1.75rem;
  background-color: ${WHATSAPP_GREEN};
  color: ${theme.colors.white};
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.25rem;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 0.2s;

  /* Cabe na coluna estreita do atendimento no mobile sem quebrar o rótulo */
  @media (max-width: 30rem) {
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }

  &:hover,
  &:focus {
    background-color: ${WHATSAPP_GREEN_HOVER};
    color: ${theme.colors.white};
  }
`
